import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { DocumentField } from '../documents/types';

const getFields: QueryFunction<
  DocumentField[],
  ['/tenant-document-fields', string]
> = async ({ queryKey }) => {
  const documentTypeId = queryKey[1];
  if (isMockServices()) return await mock(_mockSharedFields);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ fieldTypes: DocumentField[] }>(
    `/field-types/${documentTypeId}`,
    {
      method: 'GET',
      paginate: true,
      accumulateKey: 'fieldTypes',
      nextCursorKey: 'nextCursor',
      limit: 100,
    },
  );
  return response.data?.fieldTypes ?? [];
};

export default getFields;

export const _mockSharedFields = [
  {
    displayName: 'Borrower',
    name: 'borrower',
  },
  {
    displayName: 'Purpose',
    name: 'purpose',
  },
  {
    displayName: 'Loan Officer',
    name: 'loan_officer',
  },
  {
    displayName: 'Amount',
    name: 'amount',
  },
  {
    displayName: 'Credit Score',
    name: 'credit_score',
  },
  {
    displayName: 'Completion Percentage',
    name: 'completion_percentage',
  },
].map(
  (field, index) =>
    ({
      ...field,
      displayName: field.displayName,
      name: field.name,
      documentTypeId: 'document-type-id',
      description: '',
      tableSchema: [
        {
          key: 'key',
          displayName: 'Display Name',
          columnPosition: 1,
        },
      ],
      id: `field-${index}`,
      code: `field-${index}`,
      type: 'text',
    }) as DocumentField,
);
